export var BASE_FONT_SIZE = 16;